// ---- SPEED FIX (theme.liquid inline-script cost, 9 Aug 2026) ----
// Yeh function pehle theme.liquid ke andar hi ek inline <script> mein
// likha hua tha. Isme koi Liquid/server-side value use nahi hoti (koi
// {{ }} nahi) - isliye ye ek static, cacheable external file mein move
// ho sakta hai (browser ise cache kar sakta hai, dobara download nahi
// hoti). Baaki inline script (theme.strings/theme.routes/theme.settings)
// theme.liquid mein hi raha kyunke unme shop ki asal (Liquid-rendered)
// values hain, jo sirf HTML render hote waqt hi maloom hoti hain.
(function () {
  window.theme = window.theme || {};
  var theme = window.theme;
  theme.enqueueStyleUpdateQueue = [];
  theme.enqueueStyleUpdateTimeoutId = null;
  theme.enqueueStyleUpdate = function (cb) {
    clearTimeout(theme.enqueueStyleUpdateTimeoutId);
    theme.enqueueStyleUpdateQueue.push(cb);
    theme.enqueueStyleUpdateTimeoutId = setTimeout(function () {
      while (theme.enqueueStyleUpdateQueue.length > 0) {
        theme.enqueueStyleUpdateQueue.pop()();
      }
    }, 0);
  };
})();
